<template>
  <div class="tableSonTemp">
    <template v-if="data">
      <div class="ellipsisStyle" v-if="type == 'radio'">
        <el-tag>{{ data }}</el-tag>
      </div>
      <div class="ellipsisStyle" v-else-if="type == 'multi'">
        <template v-if="data.length > 0">
          <el-tag
            style="margin-right: 5px"
            v-for="(item, index) in data"
            :key="index + config.key"
            >{{ item }}</el-tag
          >
        </template>
        <div v-else>-</div>
      </div>
    </template>
    <div v-else>-</div>
  </div>
</template>
<script>
export default {
  props: ["data", "config"],
  computed: {
    type() {
      if (
        this.config.rules.selectConfig.type == "radio" ||
        this.config.rules.selectConfig.type == "radioSelect"
      ) {
        return "radio";
      } else {
        return "multi";
      }
    },
  },
};
</script>
